import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ScrollToTop } from './components/common';
import { AboutSection, ContactSection } from './components/sections';
import EnquiryButton from './components/MailfoerPage/EnquiryButton';

const Home = lazy(() => import('./pages/Home'));
const MailfoerPage = lazy(() => import('./pages/MailfoerPage'));
const Invite = lazy(() => import('./pages/Invite'));

const ROUTE_CARD_TYPES = {
  '/maifloertechnologies': 'technologies',
  '/maifloerfarmstays': 'farmstays',
  '/maifloerconstructions': 'constructions',
};

const AppContent = () => {
  const location = useLocation();

  const getCardDataFromLocation = () => {
    if (location.state?.cardType) {
      return location.state;
    }
    if (ROUTE_CARD_TYPES[location.pathname]) {
      return { cardType: ROUTE_CARD_TYPES[location.pathname] };
    }
    return { cardType: 'home' };
  };

  const cardData = getCardDataFromLocation();

  return (
    <div className="min-h-screen">
      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/contact" element={<ContactSection />} />
          <Route path="/mailfoer" element={<MailfoerPage />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/maifloertechnologies" element={<MailfoerPage cardType="technologies" />} />
          <Route path="/maifloerfarmstays" element={<MailfoerPage cardType="farmstays" />} />
          <Route path="/maifloerconstructions" element={<MailfoerPage cardType="constructions" />} />
        </Routes>
      </Suspense>
      <EnquiryButton cardData={cardData} />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
